"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsFormComponent = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const PeriodDaysComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/common/PeriodDaysComponent");
const ChartShowButtonComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/ChartShowButtonComponent");
const EventsPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsPageDataProvider");
const EventsPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsPageModelProvider");
const EventAggregationComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/state/data/EventAggregationComponent");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const QueryEventVariantsComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/event/queryEventVariant/QueryEventVariantsComponent");
const QueryEventVariantNameComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/event/queryEventVariant/QueryEventVariantNameComponent");
const react_1 = require("react");
const EventsFormComponent = () => {
    const pageDataContext = (0, EventsPageDataProvider_1.useEventsPageDataContext)();
    const pageModelContext = (0, EventsPageModelProvider_1.useEventsPageModelContext)();
    const compositeChartJSONModel = pageModelContext.pageModelStateFns.getFormJSONModel();
    const last = compositeChartJSONModel.getPeriodDaysJSONModel().getLast();
    const aggregation = compositeChartJSONModel.getCompositeChartAggregationJSONModel().getAggregation();
    const eventsJSONModel = compositeChartJSONModel.getEventsJSONModel();
    const eventsJSONModelSerializedState = eventsJSONModel.serialize();
    const showButtonDisabled = eventsJSONModel.getNumberOfQueryEventVariants() === 0;
    const transformOptionsFn = (0, react_1.useMemo)(() => {
        return (0, QueryEventVariantNameComponent_1.createTransformOptions)({
            filterOutEventsForUniqueness: false,
            specialEvents: ["session", "anyEvent"],
            specialEventsInAllRows: true
        });
    }, []);
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.Form, null,
            React.createElement(PageContent_1.default.CardSection, null),
            React.createElement(antd_1.Row, { gutter: 12 },
                React.createElement(antd_1.Col, null,
                    React.createElement(PeriodDaysComponent_1.PeriodDaysComponent, { value: last, onChange: pageModelContext.pageModelStateFns.onPeriodChanged })),
                React.createElement(antd_1.Col, null,
                    React.createElement(EventAggregationComponent_1.EventAggregationComponent, { value: aggregation, onChange: pageModelContext.pageModelStateFns.onAggregationChanged }))),
            React.createElement(PageContent_1.default.CardSection, null, "Events"),
            React.createElement(antd_1.Row, null,
                React.createElement(antd_1.Col, { span: 24 },
                    React.createElement(QueryEventVariantsComponent_1.QueryEventVariantsComponent, { queryEventVariantsSerializedState: eventsJSONModelSerializedState, onChange: pageModelContext.pageModelStateFns.onEventsChanged, transformOptions: transformOptionsFn }))),
            React.createElement(antd_1.Row, { className: "drawButtonRow" },
                React.createElement(antd_1.Col, { span: 24 },
                    React.createElement(ChartShowButtonComponent_1.ChartShowButtonComponent, { inProgress: pageDataContext.state.inProgress, onClick: pageModelContext.pageModelStateFns.show, disabled: showButtonDisabled })))));
};
exports.EventsFormComponent = EventsFormComponent;
exports.EventsFormComponent.displayName = "EventsFormComponent";
